'use strict';

var getCookie = require('./util/cookie');

module.exports = {
    /**
     * 读取维度信息
     */
    getExt: function getExt() {
        var network = getCookie('network');
        if (!network) {
            var ua = navigator.userAgent;
            var reg = /NetType\/([a-zA-Z0-9]+)/;
            if (ua && reg.test(ua)) {
                network = ua.match(reg)[1];
            }
        }
        var unionId = getCookie('unionid') || getCookie('dpid') || getCookie('_lxsdk_cuid');
        var ret = {};
        if (network) {
            ret.network = network;
        }
        if (unionId) {
            ret.unionId = unionId;
        }
        return ret;
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/@dp/owl/lib/dimns.js
// module id = 245
// module chunks = 0